import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LATEST } from "@/constants/testIds";
import { OpportunityCard } from "./OpportunityCard";
import { OpportunityCardSkeleton } from "@/components/OpportunityCardSkeleton";
import { useLatestOpportunities } from "@/hooks/useOpportunities";

export const LatestOpportunities = () => {
  const { opportunities, isLoading } = useLatestOpportunities();

  return (
    <section
      id="latest"
      data-testid={LATEST.root}
      className="bg-white"
    >
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="mb-10 flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="fursa-eyebrow">Latest Opportunities</p>
            <h2 className="fursa-section-title mt-3 font-semibold tracking-tight text-ink-900">
              فرص جديدة مضافة هذا الأسبوع
            </h2>
          </div>
          <Link
            to="/opportunities"
            data-testid={LATEST.viewAll}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-fursa-700 transition-colors hover:text-fursa-800"
          >
            عرض الكل
            <ArrowLeft className="h-4 w-4" strokeWidth={1.75} />
          </Link>
        </div>

        {isLoading ? (
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3" aria-busy="true">
            {Array.from({ length: 6 }).map((_, i) => (
              <OpportunityCardSkeleton key={i} />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
            {opportunities.map((o) => (
              <OpportunityCard key={o.id} opportunity={o} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
